<template>
  <footer>
    <p>
      <a @click="$emit('showDisclaimer')">Data Sources disclaimer</a>
    </p>
  </footer>
</template>

<script>
export default {
  name: 'app-footer',
}
</script>

<style scoped lang="scss">
footer {
  padding-bottom: 25px;
  p {
    margin-bottom: 10px;
    margin-right: 10px;
    text-align: center;
  }
  a {
    font-size: 11px;
    color: #8f949a;
    text-decoration: underline;
  }
  .copyright {
    font-size: 10px;
    color: #8f949a;
  }
}
</style>
